export default __webpack_public_path__ + "static/media/faceBotA.f72c6894.png";